var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 31,
    viewBox: "0 0 27 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0777 16.2119L4.37526 8.43066L3.67468 7.80371L4.37781 8.43359V23.7031H23.5354V8.43359L14.8279 16.2119C14.5776 16.4355 14.2697 16.5569 13.9528 16.5569C13.6359 16.5569 13.328 16.4355 13.0777 16.2119Z",
    fill: "#D5EEFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5544 5.1875H3.3588C2.90788 5.1875 2.54358 5.60645 2.54358 6.125V24.875C2.54358 25.3936 2.90788 25.8125 3.3588 25.8125H24.5544C25.0054 25.8125 25.3697 25.3936 25.3697 24.875V6.125C25.3697 5.60645 25.0054 5.1875 24.5544 5.1875ZM22.147 7.2998L13.9566 14.6211L5.76624 7.2998H22.147ZM23.5354 8.43359V23.7031H4.37782V8.43359L3.67469 7.80371L4.37527 8.43066L13.0777 16.2119C13.328 16.4355 13.6359 16.5569 13.9528 16.5569C14.2697 16.5569 14.5776 16.4355 14.8279 16.2119L23.5354 8.43359ZM23.5354 8.43359L24.2386 7.80371L23.2374 6.32422H23.2399L24.2411 7.80371L23.5354 8.43359Z",
    fill: "#0593F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.5b792b25bf0a46cd18bba7a5fcae3cf9.svg";
export { ForwardRef as ReactComponent };